/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import customStyles from "../../../assets/styles/customStyles";
import MainHeader from "../../Shared/components/Header";
import { Row, Col, Image } from "antd";
import underConstruction from "../../../assets/images/underConstruction.png";
import Menus from "./Menus";
import DeliveryIcon from "../../../assets/images/icon_menus/Delivery Icon.json";
import { useSelector } from "react-redux";
import { checkModuleViewPermission } from '../../../helpers/utilities';

const Delivery = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const leftRef = useRef('');
    const [height, setHeight] = useState(300);
    const [menuHeight, setMenuHeight] = useState(0);
    const { history } = props;
    const classes = customStyles();

    const calculateHeight = () => {
        if (document.querySelectorAll(`.menuCheck`).length > 0) {
            if (leftRef && leftRef?.current)
                setMenuHeight(leftRef.current.offsetHeight + 25);
            if (document.querySelectorAll(`.${classes.primaryMenu}`) && document.querySelectorAll(`.${classes.primaryMenu}`).length > 0 && leftRef.current) {
                let height = document.querySelectorAll(`.${classes.primaryMenu}`)[0].offsetHeight;
                let offsetHeight = leftRef?.current?.offsetHeight + height + 23;
                setHeight(offsetHeight);
            }
        }
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkModuleViewPermission('Sales', history)) {
                setTimeout(() => {
                    calculateHeight();
                }, 100);
            }
        }
    }, [roleManagement]);

    return (
        <React.Fragment>
            <MainHeader  {...props} img={DeliveryIcon} title={'Delivery'} links={[{ 'label': 'Home', 'link': '/' }, { 'label': 'Delivery', 'link': '' }]} close={false} />
            <div className={clsx(classes.listTableMargin, classes.containerBorder, classes.cardEHeight)}>
                <Row gutter={25} className={classes.dashboardRow}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={16} xxl={16}>
                        <Row gutter={25} ref={leftRef}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner, classes.boxBorderInnerConstruction)}>
                                        <Image src={underConstruction} preview={false} />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} className={classes.secondBox}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner, classes.boxBorderInnerConstruction)}>
                                        <Image src={underConstruction} preview={false} />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {
                            roleManagement !== '' && <Menus menuHeight={menuHeight} />
                        }
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} className={classes.thirdBox}>
                        <div className={clsx(classes.boxBorderH, classes.boxBorderInnerConstruction)} style={{ height: (height) + 'px' }}>
                            <Image src={underConstruction} preview={false} />
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default Delivery